<!-- Added by Amisha on 2026-06-15. Reason: keep Janus export dropdown styling opt-in through
     a root class so shared dropdown markup continues to work unchanged for non-Janus consumers. -->
<div
  class="common-dropdown-root"
  [ngClass]="data?.className"
  [style.width]="data?.style?.width"
  [style.height]="data?.style?.height"
>
  <div
    class="dropdown-control"
    [class.disabled]="data?.disabled"
    [attr.aria-disabled]="data?.disabled ? 'true' : 'false'"
    [class.red-border]="ngControl?.invalid && ngControl?.touched"
    tabindex="0"
    (click)="toggle($event)"
    (blur)="onTouched()"
    [style.height]="data?.style?.height"
    [style.minHeight]="data?.style?.height"
    [style.background]="data?.style?.background"
    [style.border]="data?.style?.border"
    [style.borderRadius]="data?.style?.borderRadius"
    [style.boxShadow]="data?.style?.boxShadow"
  >
    <!-- Prefix Icon -->
    <ng-container *ngIf="data?.prefixIcon || data?.prefixIconSvg">
      <mat-icon
        class="prefix-icon"
        *ngIf="data?.prefixIcon"
        [ngClass]="data?.prefixIconClass"
      >
        {{ data?.prefixIcon }}
      </mat-icon>

      <mat-icon
        class="prefix-icon"
        *ngIf="data?.prefixIconSvg"
        [svgIcon]="data?.prefixIconSvg"
        [ngClass]="data?.prefixIconClass"
      >
      </mat-icon>
    </ng-container>
    <span class="label" [class.placeholder]="!selectedLabel">
      <!-- {{ selectedLabel || (data?.placeholder || '') }} -->
      {{
        data?.actionMode
          ? data?.placeholder || ''
          : selectedLabel || data?.placeholder || ''
      }}
    </span>
    <mat-icon class="chev">keyboard_arrow_down</mat-icon>
  </div>

  <!-- Added by Amisha on 2026-09-15. Reason: keep other dropdown panels inline and portal only an applicant panel that overlaps the header. -->
  <ng-container
    *ngIf="open && !useApplicantOverlay"
    [ngTemplateOutlet]="dropdownPanelTemplate"
  ></ng-container>

  <!-- Added by Amisha on 2026-09-15. Reason: share the same panel markup between inline rendering and the applicant overlay. -->
  <ng-template #dropdownPanelTemplate>
  <div
    class="dropdown-panel"
    [ngStyle]="this.isJanusExportMenu ? dropdownPanelStyles : panelStyles"
    [class.checkbox-panel-mode]="data?.panelMode === 'checkbox-list'"
    (click)="$event.stopPropagation()"
  >
    <!-- Added by Vipul Rathod on 17/07/2026  -->
    <ng-container [ngSwitch]="data?.panelMode">
      <ng-container *ngSwitchDefault>
        <!-- Added by Amisha on 2026-06-15. Reason: Janus scheduled exports need a
             split dropdown layout so shared dropdown consumers can keep the default
             flat option rendering unless they opt into the Janus export class hook. -->
        <ng-container *ngIf="isJanusExportMenu; else defaultDropdownOptions">
          <div
            class="janus-export-panel-shell"
            [class.has-scrollable-middle]="hasJanusScrollableMiddle"
          >
            <div
              class="item"
              *ngFor="let option of janusTopOptions"
              (click)="select(option)"
              [class.selected]="!data?.actionMode && _value === option.value"
              [class.divider]="option.isDivider"
              [attr.aria-selected]="_value"
              [class.disabled]="option.disabled"
              [ngClass]="option.className"
              [attr.title]="option.tooltip || null"
              role="option"
            >
              <span *ngIf="!option.isDivider">{{ option.label }}</span>
            </div>

            <div class="janus-export-scroll-region" *ngIf="janusMiddleOptions.length > 0">
              <!-- Added by Amisha on 2026-06-15. Reason: only the scheduled export names
                   should scroll; the top formats and bottom create action stay fixed. -->
              <div
                class="item"
                *ngFor="let option of janusMiddleOptions"
                (click)="select(option)"
                [class.selected]="!data?.actionMode && _value === option.value"
                [class.divider]="option.isDivider"
                [attr.aria-selected]="_value"
                [class.disabled]="option.disabled"
                [ngClass]="option.className"
                [attr.title]="option.tooltip || null"
                role="option"
              >
                <span *ngIf="!option.isDivider">{{ option.label }}</span>
              </div>
            </div>

            <div
              class="item"
              *ngFor="let option of janusBottomOptions"
              (click)="select(option)"
              [class.selected]="!data?.actionMode && _value === option.value"
              [class.divider]="option.isDivider"
              [attr.aria-selected]="_value"
              [class.disabled]="option.disabled"
              [ngClass]="option.className"
              [attr.title]="option.tooltip || null"
              role="option"
            >
              <span *ngIf="!option.isDivider">{{ option.label }}</span>
            </div>
          </div>
        </ng-container>

      </ng-container>
      <ng-container *ngSwitchCase="'checkbox-list'">
        <div class="checkbox-panel">
          <div
            class="checkbox-panel-title"
            *ngIf="data.checkboxPanel?.title">
            {{data.checkboxPanel.title}}
          </div>
          <div class="checkbox-header">
              <div class="left">
                {{data.checkboxPanel?.leftHeader}}
              </div>
              <div class="checkbox-actions">
                <div
                  class="checkbox-cell"
                  *ngFor="let header of data.checkboxPanel?.rightHeaders">
                  {{header}}
                </div>
              </div>
          </div>
          <div
              class="checkbox-row select-all"
              *ngIf="data.checkboxPanel?.showSelectAll">
              <div>
                  {{data.checkboxPanel?.selectAllLabel || 'Select All'}}
              </div>
              <div class="checkbox-actions">
                <div
                    class="checkbox-cell"
                    *ngFor="let header of data.checkboxPanel?.rightHeaders; let i=index">
                    <mat-checkbox
                        [checked]="allTriggered"
                        (change)="selectAllChanged(i,$event.checked)">
                    </mat-checkbox>
                </div>
              </div>
          </div>
          <div class="checkbox-body">
            <div
                class="checkbox-row"
                *ngFor="let item of data.checkboxPanel?.items">
                <div class="left">
                    {{item.label}}
                </div>
                <div class="checkbox-actions">
                  <div
                      class="checkbox-cell"
                      *ngFor="let check of item.checks; let checkIndex=index">
                      <mat-checkbox
                        [checked]="check.checked"
                        [disabled]="check.disabled"
                        (change)="checkboxChanged(item.id, checkIndex, $event.checked)">
                      </mat-checkbox>
                  </div>
                </div>
            </div>
          </div>
        </div>
      </ng-container>
    </ng-container>
    <!-- End by Vipul Rathod on 17/07/2026  -->

    <ng-template #defaultDropdownOptions>
      <!-- Added by Amisha on 2026-06-15. Reason: divider rows are only rendered for menus
           that explicitly mark an option as a divider, which keeps existing dropdowns unaffected. -->
      <!-- Added by Amisha on 2026-07-23.
           Reason: opt-in dropdowns must select on the first pointer interaction inside inline overlays. -->
      <div
        class="item"
        *ngFor="let option of data?.options"
        (pointerdown)="selectOnPointerDown($event, option)"
        (click)="completePointerSelection($event, option)"
        [class.selected]="!data?.actionMode && _value === option.value"
        [class.divider]="option.isDivider"
        [attr.aria-selected]="_value"
        [class.disabled]="option.disabled"
        [ngClass]="option.className"
        [attr.title]="option.tooltip || null"
        role="option"
      >
        <span *ngIf="!option.isDivider">{{ option.label }}</span>
      </div>
    </ng-template>
  </div>
  </ng-template>
</div>
